export default {
  namespaced: true,
  state: {
    vehicleApplication: null
  },
  getters: {
    vehicleApplication(state) {
      return state.vehicleApplication;
    },
    scoreboardStatus(state) {
      return state.vehicleApplication?.scoreboard?.status ? state.vehicleApplication?.scoreboard?.status : null;
    },
    isStatusDraft(state) {
      return state.vehicleApplication.applicationStatus === 'draft';
    },
    isDocusignCompleted(state) {
      return state.vehicleApplication.scoreboard.docusignStatus === 'completed';
    },
    isDocusignCreated(state) {
      return state.vehicleApplication.scoreboard.docusignStatus === 'created';
    },
    isWetSignature(state) {
      return state.vehicleApplication.scoreboard.wetSignature && state.vehicleApplication.scoreboard.wetSignature.signType === 'wet';
    },
    isDocusignNotCreated(state) {
      return state.vehicleApplication.scoreboard.docusignStatus === 'none';
    },
    isUserPrimaryApplicant(state, getters, rootState) {
      const appType = String(state.vehicleApplication?.applicationType || '').toLowerCase();
      if ((appType === 'calculator' || appType === 'scoreboard') && !state.vehicleApplication?.scoreboard?.primaryApplicant) {
        return true;
      }

      if (
        state.vehicleApplication &&
        state.vehicleApplication.scoreboard &&
        state.vehicleApplication.scoreboard.primaryApplicant &&
        rootState.auth &&
        rootState.auth.user &&
        state.vehicleApplication.scoreboard.primaryApplicant.userId == rootState.auth.user.id
      )
        return true;
      else return false;
    },
    isUserSecondaryApplicant(state, getters, rootState) {
      if (
        state.vehicleApplication &&
        state.vehicleApplication.scoreboard &&
        state.vehicleApplication.scoreboard.secondaryApplicant &&
        rootState.auth &&
        rootState.auth.user &&
        state.vehicleApplication.scoreboard.secondaryApplicant.userId == rootState.auth.user.id
      )
        return true;
      else return false;
    },
    isCalculatorApplicant(state, getters, rootState) {
      if (!state.vehicleApplication || !rootState.auth?.user) {
        return false;
      }
      const t = String(state.vehicleApplication.applicationType || '').toLowerCase();
      return t === 'calculator' || t === 'scoreboard';
    },
    getPrimaryApplicantIDScanData(state) {
      return state.vehicleApplication.scoreboard.primaryApplicant.idScanData;
    },
    getSecondaryApplicantIDScanData(state) {
      return state.vehicleApplication.scoreboard.secondaryApplicant.idScanData;
    },
    getApplicantIDScan(state, applicantType) {
      return state.vehicleApplication.scoreboard?.[applicantType].idScanData;
    },
    errorCounts: (state) => (applicantType) => {
      return state.vehicleApplication.scoreboard?.[applicantType]?.idScanData?.idScan?.errorCount;
    }
  },
  mutations: {
    clearVehicleApplication(state) {
      state.vehicleApplication = null;
    },
    setVehicleApplication(state, vehicleApplication) {
      state.vehicleApplication = vehicleApplication;
    },
    setEntityDetailsStatus(state, entityDetails) {
      state.vehicleApplication.scoreboard.entityDetails = entityDetails;
    },
    updateWetSignature(state, params) {
      const { uploadFile, wetSignatureObjName } = params;
      if (state.vehicleApplication.scoreboard.wetSignature && state.vehicleApplication.scoreboard.wetSignature[wetSignatureObjName])
        state.vehicleApplication.scoreboard.wetSignature[wetSignatureObjName].uploadFile = uploadFile;
    },
    setIDScanDataStatus(state, params) {
      const { isUserPrimaryApplicant, data } = params;
      if (isUserPrimaryApplicant) state.vehicleApplication.scoreboard.primaryApplicant.idScanData = data;
      else state.vehicleApplication.scoreboard.secondaryApplicant.idScanData = data;
    },
    saveDrivingLicense(state, params) {
      const { files, applicantType } = params;
      state.vehicleApplication.scoreboard[applicantType].idScanData.fileUrls = files;
    },
    setValue(state, params) {
      const { value, propertyFirst, propertySecond, propertyThird } = params;
      if (propertySecond && propertyThird) {
        if (state.vehicleApplication.scoreboard[propertyFirst] && state.vehicleApplication.scoreboard[propertyFirst][propertySecond])
          state.vehicleApplication.scoreboard[propertyFirst][propertySecond][propertyThird] = value;
        else if (state.vehicleApplication.scoreboard[propertyFirst])
          state.vehicleApplication.scoreboard[propertyFirst][propertySecond] = {
            [propertyThird]: value
          };
        else
          state.vehicleApplication.scoreboard[propertyFirst] = {
            [propertySecond]: {
              [propertyThird]: value
            }
          };
      } else if (propertySecond) {
        if (state.vehicleApplication.scoreboard[propertyFirst]) state.vehicleApplication.scoreboard[propertyFirst][propertySecond] = value;
        else
          state.vehicleApplication.scoreboard[propertyFirst] = {
            [propertySecond]: value
          };
      } else state.vehicleApplication.scoreboard[propertyFirst] = value;
    }
  },
  actions: {
    updateEntityDetailsState({ commit, state }, entityDetails) {
      commit('setEntityDetailsStatus', entityDetails);
    },
    updateWetSignatureState({ commit, state }, params) {
      commit('updateWetSignature', params);
    },
    updateVehicleApplicationState({ commit, state }, params) {
      commit('setValue', params);
    }
  }
};
